export default __webpack_public_path__ + "static/media/PSD.90f3562b.png";